import React from 'react';
import { useLocation } from 'react-router-dom';
import { IoClose } from 'react-icons/io5';
import { BsPlayCircleFill } from 'react-icons/bs';
import { MdOutlineTravelExplore } from 'react-icons/md';
import { useHelp } from './HelpContext';
import { getVideosForRoute, getAllVideos } from './HelpVideos';
import { TOUR_STEPS } from './TourSteps';
import './Help.css';

const VideoCard = ({ video, onWatch }) => {
  const hasThumbnail = video.id !== 'PLACEHOLDER';
  return (
    <div className="help-video-card">
      <div className="help-video-thumbnail">
        {hasThumbnail ? (
          <img
            src={`https://img.youtube.com/vi/${video.id}/mqdefault.jpg`}
            alt={video.title}
            className="help-thumbnail-img"
          />
        ) : (
          <div className="help-thumbnail-placeholder">
            <BsPlayCircleFill size={32} color="#C9194A" />
          </div>
        )}
      </div>
      <div className="help-video-info">
        <div className="help-video-title">{video.title}</div>
        <div className="help-video-desc">{video.description}</div>
        <button
          className="help-watch-btn"
          onClick={() => onWatch(video)}
          disabled={!hasThumbnail && video.id === 'PLACEHOLDER'}
          title={video.id === 'PLACEHOLDER' ? 'Video coming soon' : 'Watch tutorial'}
        >
          {video.id === 'PLACEHOLDER' ? 'Coming Soon' : '▶ Watch'}
        </button>
      </div>
    </div>
  );
};

const HelpPanel = ({ onClose }) => {
  const { playVideo, startTour } = useHelp();
  const location = useLocation();

  const pageVideos = getVideosForRoute(location.pathname);
  const allVideos = getAllVideos();
  const hasTour = Boolean(TOUR_STEPS[location.pathname]?.length);

  const handleWatch = (video) => {
    if (video.id === 'PLACEHOLDER') return;
    playVideo(video);
    onClose();
  };

  const handleStartTour = () => {
    startTour();
    onClose();
  };

  return (
    <>
      <div className="help-panel-backdrop" onClick={onClose} />
      <div className="help-panel">
        <div className="help-panel-header">
          <div>
            <div className="help-panel-title">Help &amp; Tutorials</div>
            <div className="help-panel-subtitle">Learn how to use EzeitPro</div>
          </div>
          <button className="help-panel-close" onClick={onClose} aria-label="Close">
            <IoClose size={20} />
          </button>
        </div>

        {hasTour && (
          <div className="help-tour-banner">
            <div className="help-tour-text">
              <strong>New to this page?</strong>
              <span>Take a guided tour to learn what everything does.</span>
            </div>
            <button className="help-tour-btn" onClick={handleStartTour}>
              <MdOutlineTravelExplore size={14} style={{ marginRight: 4 }} />
              Take a Tour
            </button>
          </div>
        )}

        <div className="help-panel-body">
          {pageVideos.length > 0 && (
            <section className="help-section">
              <div className="help-section-label">
                <span className="help-section-badge">This Page</span>
              </div>
              {pageVideos.map((video, i) => (
                <VideoCard key={i} video={video} onWatch={handleWatch} />
              ))}
            </section>
          )}

          <section className="help-section">
            <div className="help-section-label">
              <span className="help-section-badge help-section-badge--all">All Tutorials</span>
            </div>
            {allVideos.map((video, i) => (
              <VideoCard key={i} video={video} onWatch={handleWatch} />
            ))}
          </section>
        </div>

        <div className="help-panel-footer">
          <a
            href="https://www.youtube.com/@EzeitPro"
            target="_blank"
            rel="noreferrer"
            className="help-channel-link"
          >
            Visit our YouTube Channel →
          </a>
        </div>
      </div>
    </>
  );
};

export default HelpPanel;
